var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { forwardRef } from 'react';
import { useGeneratedId } from 'modules/utils';
import { useDescriptionWarning } from './utils';
import { Label } from '../Label';
import { Container, Input, Description, InputContainer, Adornment } from './styled';
export const TextInput = forwardRef((props, forwardedRef) => {
    const autoId = useGeneratedId('textinput');
    const { appearance = 'outline', id = autoId, label, 'aria-describedby': ariaDescribedBy, description, stretch = false, invalid = false, disabled = false, adornmentLeft, adornmentRight, defaultValue, value, onChange } = props, restProps = __rest(props, ["appearance", "id", "label", 'aria-describedby', "description", "stretch", "invalid", "disabled", "adornmentLeft", "adornmentRight", "defaultValue", "value", "onChange"]);
    const handleChange = (event) => {
        if (onChange) {
            onChange(event);
        }
    };
    const describedBy = ariaDescribedBy || (description && `${id}-description`);
    useDescriptionWarning({ ariaDescribedBy, description });
    const inputProps = Object.assign(Object.assign({}, restProps), { ref: forwardedRef, id,
        disabled, 'aria-describedby': describedBy, defaultValue,
        value, onChange: handleChange });
    return (<Container $stretch={stretch}>
      {label && (<Label htmlFor={id} $invalid={invalid}>
          {label}
        </Label>)}
      <InputContainer $invalid={invalid} $appearance={appearance}>
        {adornmentLeft && <Adornment>{adornmentLeft}</Adornment>}
        <Input {...inputProps}/>
        {adornmentRight && <Adornment>{adornmentRight}</Adornment>}
      </InputContainer>
      {description && (<Description $invalid={invalid} id={describedBy} $disabled={disabled}>
          {description}
        </Description>)}
    </Container>);
});
